import React, { useState, useEffect } from "react";
import { useAccount } from "wagmi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AcceptCult.css";

const API_URL = "https://mon-cultists.xyz/api/whitelist";

const AcceptCult = () => {
  const { address, isConnected } = useAccount();
  const [remainingSpots, setRemainingSpots] = useState(1000);
  const [isWhitelisted, setIsWhitelisted] = useState(false);

  // Загружаем количество оставшихся мест
  useEffect(() => {
    fetch(`${API_URL}/count`)
      .then((res) => res.json())
      .then((data) => setRemainingSpots(data.remaining));
  }, []);

  // Проверяем, в вайтлисте ли уже этот кошелек
  useEffect(() => {
    if (!address) return;
    fetch(`${API_URL}/check`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ wallet: address }),
    })
      .then((res) => res.json())
      .then((data) => setIsWhitelisted(data.inWhitelist));
  }, [address]);

  // Запрос на вступление в культ (добавление в вайтлист)
  const handleJoinCult = async () => {
    if (!isConnected) {
      toast.warn("Please connect your wallet");
      return;
    }

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ wallet: address }),
      });

      const data = await response.json();
      if (data.success) {
        setIsWhitelisted(true);
        setRemainingSpots((prev) => prev - 1);
        toast.success("You have joined the cult!");
      } else {
        toast.error(data.error);
      }
    } catch (error) {
      toast.error("Error joining the cult");
    }
  };

  return (
    <div className="cult-container">
      <h1>Accept the Cult</h1>
      <img src="/images/Early_cultist.png" alt="Cultist NFT" className="cultist-image" />
      <p className="cult-description">
      Whispers from the void call upon the worthy.<br/>
      A sacred pact awaits—etched in shadow, bound by fate.<br/>
      Do you dare embrace the unknown? <br/>
      <span className="shaking-text">The cult watches...</span>
      </p>

      <p className="spots-left">Spots left: {remainingSpots}</p>

      <button 
        onClick={handleJoinCult} 
        className="cult-button" 
        disabled={isWhitelisted || remainingSpots === 0}
      >
        {isWhitelisted ? "You have joined the cult." : "Accept the cult"}
      </button>
    </div>
  );
};

export default AcceptCult;
